module.exports = __webpack_public_path__ + "static/media/icon-character__francois-mitterrand-hover.65c20896.svg";